/**
 * Classification des rubriques de paie — fiche technique Gabon CGI 2026 v2.0.
 *
 * Cat 1 — Salaire + primes imposables → CNSS + CNAMGS + TCS + IRPP
 * Cat 2 — Indemnités in-brut → CNSS uniquement (exclues CNAMGS / TCS / IRPP)
 * Cat 3 — Non cotisables → hors brut, ajoutés au net
 */
export enum CategorieRubrique {
  CAT1_IMPOSABLE = 1,
  CAT2_INDEM_BRUT = 2,
  CAT3_NON_COTISAL = 3,
}

export interface RubriquePaie {
  /** Code du référentiel paie v2 (onglet RUBRIQUES : 10000…40050) ou code interne `X-…`. */
  code: string;
  libelle: string;
  categorie: CategorieRubrique;
  montant: number;
  /**
   * Groupe d'exonération IRPP (art. 91 §11). N'a d'effet que si le paramètre
   * `exonerationArt9111Active` est activé ; désactivé par défaut.
   */
  exoIrppGroupe?: 'art91_11';
}

export interface AgregatsRubriques {
  cat1_total: number;
  cat2_total: number;
  cat3_total: number;
  /** « Total Brut » du référentiel = cat1 + cat2 (cat3 hors brut, ajoutée au net). */
  brut_total: number;
}
